import React from "react";
import Styles from "./SideBar.module.scss";
import {Upload , EventLog , Load} from './progress/Icons'
const Progress = ({page}) => {
    return(
        <div className={Styles.progress}>
            <div className={`${Styles.itemBox} d-flex`}>
                <div className={`${Styles.item} ${(page === 'Upload File' || page === 'Source Preview') ? Styles.active : ''} d-flex justify-content-center align-items-center mr-3`}>
                    {Upload}
                </div>
                <div>
                    <p className="dark-gary-2 f16 fw500 mt-1">01 Upload File</p>
                    <p className="gray f12 fw300 mt-1">Select and upload your files</p>
                </div>
            </div>
           <div className={`${Styles.itemBox} d-flex`}>
               <div className={`${Styles.item} ${(page === 'Error' || page === 'Generate Connector' || page === 'Data Preview' || page === 'Add Columns') ? Styles.active : ''} d-flex justify-content-center align-items-center mr-3`}>
                   {EventLog}
               </div>
               <div>
                   <p className="dark-gary-2 f16 fw500 mt-1">02 Eventlog</p>
                   <p className="gray f12 fw300 mt-1">Choose a template and edit</p>
               </div>
           </div>
          <div className={`${Styles.itemBox} d-flex`}>
              <div className={`${Styles.item} ${page === 'Load Data' ? Styles.active : ''} d-flex justify-content-center align-items-center mr-3`}>
                  {Load}
              </div>
              <div>
                  <p className="dark-gary-2 f16 fw500 mt-1">03 Load</p>
                  <p className="gray f12 fw300 mt-1">Load your edited eventlog</p>
              </div>
          </div>
        </div>
    )
}
export default Progress;